import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { StyleHelperService } from '../../core/style-helper/style-helper.service';

@Injectable({ providedIn: 'root' })
export class StyleLoadGuard implements CanActivate {

  constructor(
    private styleHelperService: StyleHelperService
  ) { }

  /**
   * @name canActivate
   * @description method implemented to be a guard deciding if style loaded or not.
   * @returns Observable<boolean>
   */
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const styleBundle: string = route.data.styleBundle;
    return this.styleHelperService.loadStyle(styleBundle);
  }
}
